exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item[data-v-43bfdf01]{display:-webkit-box;display:-ms-flexbox;display:flex}.menu-item:hover>div.dropdown-content[data-v-43bfdf01]{display:block}.menu-hiding-label[data-v-43bfdf01]{white-space:nowrap}.dropdown-content[data-v-43bfdf01]{display:none;white-space:nowrap;padding-bottom:0;padding-top:0;margin-top:-9px;position:fixed;left:56px}.icon.angle[data-v-43bfdf01]{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43bfdf01","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/menu/MenuItem.vue
// module id = f82t
// module chunks = 66